import { render } from "./AddNotificationView.vue?vue&type=template&id=5ae46097"
import script from "./AddNotificationView.vue?vue&type=script&lang=js"
export * from "./AddNotificationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__